import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import { refusedSIAOptions } from '@mummssoftware/utils/hope';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import styled from 'styled-components';

const SFVWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ControlWrapper = styled.div`
  margin: 5px;
`;

type SFVContentProps = {
  handleChange: any;
  value: any;
};

export const SFVContent = ({ handleChange, value }: SFVContentProps) => {
  const message = `Select reason no SFV was completed.`;
  const reasons = Object.entries(refusedSIAOptions);
  return (
    <SFVWrapper>
      <div>{message}</div>
      <FormControl component="fieldset">
        <ControlWrapper>
          <RadioGroup
            value={value || ''}
            onChange={(event: any) => handleChange(event.target.value)}
          >
            {reasons.map((reason: any) => (
              <FormControlLabel
                key={reason[0]}
                value={reason[0]}
                label={reason[1]}
                control={
                  <Radio key={`${reason[0]}-${reason[1]}`} size="small" />
                }
              />
            ))}
          </RadioGroup>
        </ControlWrapper>
      </FormControl>
    </SFVWrapper>
  );
};
